export const RELEVANT_ACTIVITY_PADDING_MS = 20 * 60 * 1000
export const RELEVANT_ACTIVITY_FULL_RANGE_TOLERANCE_MS = 500

function summaryTimesForSegment(summary, segmentLabel) {
  const includeStart = segmentLabel === 'start' || segmentLabel === 'trip'
  const includeFinish = segmentLabel === 'finish' || segmentLabel === 'trip'
  const times = []
  if (includeStart) {
    times.push(
      summary.planned_start,
      summary.hos_start,
      summary.vehicle_start,
      summary.ignition_start,
      summary.dvir_start,
    )
  }
  if (includeFinish) {
    times.push(
      summary.planned_finish,
      summary.hos_finish,
      summary.vehicle_finish,
      summary.ignition_finish,
      summary.dvir_finish,
    )
  }
  return times
}

/** Zoom window from earliest to latest actuals milestone in the segment. */
export function computeRelevantActivityWindow({
  windowStartMs,
  windowEndMs,
  segmentLabel = 'trip',
  summary = {},
  parseTimeMs = value => value,
  paddingMs = RELEVANT_ACTIVITY_PADDING_MS,
} = {}) {
  if (windowStartMs == null || windowEndMs == null || windowEndMs <= windowStartMs)
    return null

  const milestoneMs = summaryTimesForSegment(summary, segmentLabel)
    .map(value => parseTimeMs(value))
    .filter(ms => ms != null && ms >= windowStartMs && ms <= windowEndMs)

  if (!milestoneMs.length)
    return null

  const activityStart = Math.max(windowStartMs, Math.min(...milestoneMs) - paddingMs)
  const activityEnd = Math.min(windowEndMs, Math.max(...milestoneMs) + paddingMs)
  if (activityEnd <= activityStart)
    return null

  return {
    startMs: Math.round(activityStart),
    endMs: Math.round(activityEnd),
  }
}

export function canZoomToRelevantActivity({
  windowStartMs,
  windowEndMs,
  activityWindow,
  toleranceMs = RELEVANT_ACTIVITY_FULL_RANGE_TOLERANCE_MS,
} = {}) {
  if (!activityWindow || windowStartMs == null || windowEndMs == null)
    return false
  const baseSpan = windowEndMs - windowStartMs
  const activitySpan = activityWindow.endMs - activityWindow.startMs
  return activitySpan < baseSpan - toleranceMs
}

export function isZoomedToRelevantActivity({
  activityWindow,
  effectiveStartMs,
  effectiveEndMs,
  toleranceMs = RELEVANT_ACTIVITY_FULL_RANGE_TOLERANCE_MS,
} = {}) {
  if (!activityWindow || effectiveStartMs == null || effectiveEndMs == null)
    return false
  return Math.abs(effectiveStartMs - activityWindow.startMs) <= toleranceMs
    && Math.abs(effectiveEndMs - activityWindow.endMs) <= toleranceMs
}
